import './styles/libs.scss';
import './styles/main.scss';

import $ from 'jquery';
import 'jquery-validation';
import 'jquery-validation-unobtrusive';

$(function () {
    const viewNames = [...new Set(
        $('[data-views]')
            .map((_, el) => $(el).data('views')?.split(','))
            .get()
            .flat()
            .filter(Boolean)
    )];

    viewNames.forEach(async viewName => {
        try {
            if (viewName === 'website-login') {
                await import(/* webpackChunkName: "website-login" */ './js/views/website-login.js');
            }
            if (viewName === 'security-challenge') {
                await import(/* webpackChunkName: "security-challenge" */ './js/views/security-challenge.js');
            }
            if (viewName === 'forgot-password') {
                await import(/* webpackChunkName: "forgot-password" */ './js/views/forgot-password.js');
            }
            if (viewName === 'change-password') {
                await import(/* webpackChunkName: "change-password" */ './js/views/change-password.js');
            }
            if (viewName === 'error') {
                await import(/* webpackChunkName: "error" */ './js/views/error.js');
            }
        } catch (error) {
            console.error(`Failed to load Js for ${viewName}:`, error);
        }
    })
});